import React from "react";
import IconButton from "@material-ui/core/IconButton";
import MoreIcon from "@material-ui/icons/MoreHoriz";
import ChevronRightRoundedIcon from "@material-ui/icons/ChevronRightRounded";
import { Button } from "@my-scoot/component-library-legacy";

export const PrimaryActionField = ({ onClick }) => {
  return (
    <IconButton onClick={onClick} className="">
      <MoreIcon />
    </IconButton>
  );
};

export const MoreActionsButton = ({ label, onClick }) => {
  return (
    <Button
      size="thin"
      color="link"
      variant="text"
      disableTouchRipple={true}
      className="!tw-bg-transparent tw-w-max tw-font-normal"
      onClick={onClick}
    >
      <span>{label}</span>
      <ChevronRightRoundedIcon />
    </Button>
  );
};
